import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import BonsLivraison from "@/pages/BonsLivraison";
import BonsIntervention from "@/pages/BonsIntervention";
import DevisAcceptes from "@/pages/DevisAcceptes";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Search from "@/pages/Search";
import MailConnector from "@/pages/MailConnector";
import ScannerConnector from "@/pages/ScannerConnector";
import Suppliers from "@/pages/Suppliers";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/factures" element={<Invoices excludeTypes={["bon_livraison", "bon_intervention", "devis_accepte"]} />} />
                            <Route path="/bons-livraison" element={<BonsLivraison />} />
                            <Route path="/bons-intervention" element={<BonsIntervention />} />
                            <Route path="/devis-acceptes" element={<DevisAcceptes />} />
                            <Route path="/recherche" element={<Search />} />
                            <Route path="/fournisseurs" element={<Suppliers />} />
                            <Route path="/connecteur-mail" element={<MailConnector />} />
                            <Route path="/scanner" element={<ScannerConnector />} />
                            <Route path="/rapports" element={<Reports />} />
                            <Route path="/parametres" element={<Settings />} />
                            {/* /navigateur removed — Playwright live browser deprecated in favour of cookies mode */}
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
